import React from 'react';
import Heading2 from '@Components/heading_2/view';
import Heading3 from '@Components/heading_3/view';

import s from '../styles/DetailContent.module.css';

const Knowledge1 = () => {
    return (
        <div className={s.wrapper}>
            <section className={s.section}>
                <Heading2 title='ゴルフ会員権のメリット' fontWeight={700} />
                <Heading3 title='メンバー料金でプレーするほどお得に！' />
                <p>
                    ゴルフ会員権を取得しメンバーになると、ビジター料金よりグッとお得な<strong>メンバー料金</strong>
                    でゴルフ場を利用することが出来ます。
                    <br />
                    <br />
                    会員権を持っている限りは、ずっとメンバー料金が適用されるので、プレーを重ねた分だけお得になり、ビジター料金とメンバー料金の差額でゴルフ会員権の元が取れます。
                    <br />
                    また、一回のプレー料金が安くなることで気軽に何度も通えるという大きなメリットもございます。
                    <br />
                </p>

                <Heading3 title='好きな時間に予約を取ることが出来る' />
                <p>
                    ゴルフ会員権を購入することで、ゴルフ場からの様々な優遇を受けることが出来ます。
                    <br />
                    <br />
                    <strong>
                        <u>練習場やレストランの利用のみも可能に</u>
                    </strong>
                    <br />
                    練習場の利用はもちろん、レストランの利用だけも歓迎しているゴルフ場も数多く存在し、家族みんながゴルフ場を好きになる仕組みがあります。
                    <br />
                    <br />
                    <strong>
                        <u>その他</u>
                    </strong>
                    <br />
                    <br />
                    ・専用ロッカーの利用
                    <br />
                    ・割引券の発行
                    <br />
                    ・家族優待制度
                    <br />
                    <br />
                    など練習場・レストラン利用以外にもたくさんのメリットがあります。
                </p>
            </section>

            <section className={s.section}>
                <Heading2 title='ゴルフ上達への近道' fontWeight={700} />

                <Heading3 title='ゴルフ場主催の競技大会に参加できる' />
                <p>
                    メンバーであればゴルフ場が主催する競技会に参加することが出来ます。
                    普段のリラックスした楽しいプレーとは変わって、緊張感のなかで自分の実力を出し切る真剣なゴルフプレーを味わうのも、ゴルフ熱が高まる1つの要素となります。
                    また、競技大会に出ることでゴルフ上級者に教わるきっかけにもなります。
                </p>

                <Heading3 title='ホームコースを持つことが出来る' />
                <p>
                    自分のホームコースを持つことで成長をより明確に実感することが出来ます。
                    <br />
                    数をこなすことで自分のミスの傾向がわかり、試行錯誤していくうちにどんどん成長することが出来ます。
                    <br />
                    <br />
                    毎回違うゴルフ場でプレーするのも刺激的で楽しいですが、ゴルフの実力をもっと上げたいのなら、まずはホームコース極めることこそが成長への近道です。
                    <br />
                </p>
            </section>

            <section className={s.section}>
                <Heading2 title='親しい仲間との楽しいひと時' fontWeight={700} />

                <Heading3 title='仲間を引き連れて楽しくゴルフ' />
                <p>
                    ゴルフ会員権を購入することは『自分のホームコースを持つこと』になり、気軽に仲間を引き連れて一緒にゴルフを楽しむこと出来ます。
                    <br />
                    <br />
                    良いショットが出来た時は『ナイスショット！』と褒め合い、上手くいかなかった時は『ドンマイ！ドンマイ！』と、気の知れた仲間たちとのゴルフプレーはとても楽しく、充実したゴルフライフを過ごせます。
                </p>

                <Heading3 title='夫婦で円満なゴルフライフ' />
                <p>
                    ゴルフは緑溢れる景色の中で、男女で会話をしながら楽しめるスポーツです。
                    <br />
                    夫婦でメンバー会員になられる方も非常に多く、「夫婦円満の秘訣は週末のゴルフ」とおっしゃられる会員様もかなりいらっしゃいます。
                    <br />
                    <br />
                    日頃の運動不足を解消出来たり、ゴルフが終わったらレストランで何気ないひと時を過ごせたりと、充実したゴルフライフをご夫婦で過ごすことが出来ます。
                </p>

                <Heading3 title='新たなゴルフ仲間と巡り合える' />
                <p>
                    ゴルフクラブの会員になると、様々な出会いがあります。
                    <br />
                    ゴルフは知らない人同士でもプレーを共にすれば自然と仲良くなれる魔法のスポーツです。
                    <br />
                    <br />
                    ゴルフで仲良くなった人はゴルフ場だけでの関係ではなく、時にはビジネスの場やプライベートなどで深い関わりを持つことことが度々あり、新たな人脈形成の場としてもゴルフ場は利用されています。
                    <br />
                    そもそもゴルフ会員権とは何かという基礎知識は<a href='/knowledge/8'>こちら</a>をご覧ください。
                </p>
            </section>
        </div>
    );
};

export default Knowledge1;
